import React from "react";
import { useHistory } from "react-router-dom";
import { Routes } from "../routes";
import useLocalStorage from "../hooks/useLocalStorage";
export default function Layout({ children }) {
  const [auth, _] = useLocalStorage("token");
  const history = useHistory();
  if (!auth) {
    history.push(Routes.Signin.path);
  }
  return <div>{children}</div>;
}
